import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SadieCallResponse } from "@/types";

export function useGetSadieCalls() {
  return useQuery({
    queryKey: ["sadie-calls"],
    queryFn: async () => {
      const res = await guacHttpClient.get<
        SadieCallResponse[],
        HttpResponse<SadieCallResponse[]>
      >("relationships/calls");
      return res.data;
    },
  });
}
